import { motion } from "framer-motion";
import NidraMark from "./NidraMark";

const EASE = [0.16, 1, 0.3, 1];

export default function Hero({ total }) {
  const hit = total != null && total >= 200;
  const yesText =
    total == null
      ? ""
      : hit
        ? `${total} HAVE SAID YES. THE LIST STAYS OPEN.`
        : `${total} OF 200 HAVE SAID YES`;
  const line1 = hit ? "200 of you said" : "we won’t launch until";
  const line2 = hit ? "yes..." : "200 of you say yes...";

  const goToForm = () => {
    const el = document.getElementById("waitlist");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section className="relative flex min-h-screen items-center justify-center overflow-hidden px-6">
      <NidraMark className="right-[-6%] top-1/2 hidden -translate-y-1/2 sm:block" />
      <div
        aria-hidden="true"
        className="absolute left-1/2 top-14 h-80 w-80 -translate-x-1/2 rounded-full opacity-90 blur-3xl transition-transform duration-1000"
        style={{
          background: hit
            ? "radial-gradient(circle, #FDE7EF 0%, #E3D5F6 50%, rgba(255,255,255,0) 78%)"
            : "radial-gradient(circle, #FADCE7 0%, #E1EFFC 55%, rgba(255,255,255,0) 78%)",
          transform: `translateX(-50%) scale(${hit ? 1.5 : 1})`,
        }}
      />
      <div
        aria-hidden="true"
        className="absolute bottom-[-12%] left-[-8%] h-72 w-72 rounded-full opacity-80 blur-3xl"
        style={{
          background: "radial-gradient(circle, #E1EFFC 0%, rgba(255,255,255,0) 70%)",
        }}
      />

      <div className="relative mx-auto max-w-4xl pt-16 text-center">
        <h1
          data-testid="hero-title"
          className="font-display text-[2.6rem] font-medium leading-[1.06] tracking-tight text-[#171512] sm:text-6xl lg:text-7xl"
        >
          <span className="block overflow-hidden pb-1">
            <motion.span
              key={line1}
              className="block"
              initial={{ y: "110%" }}
              animate={{ y: 0 }}
              transition={{ duration: 0.9, ease: EASE, delay: 0.25 }}
            >
              {line1}
            </motion.span>
          </span>
          <span className="block overflow-hidden pb-2">
            <motion.span
              key={line2}
              className="block font-serif italic"
              initial={{ y: "110%" }}
              animate={{ y: 0 }}
              transition={{ duration: 0.9, ease: EASE, delay: 0.4 }}
            >
              {line2}
            </motion.span>
          </span>
        </h1>

        <motion.p
          data-testid="hero-manifesto-text"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: EASE, delay: 0.7 }}
          className="mx-auto mt-8 max-w-xl text-base leading-relaxed text-[#171512]/60 sm:text-lg"
        >
          We are starting with sleep, the most everyday fundamental problem of them all. The first
          drop is limited, and this page is the only way in.
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.9, ease: EASE, delay: 0.9 }}
          className="mt-12 flex flex-col items-center gap-5"
        >
          <button
            data-testid="hero-cta-button"
            onClick={goToForm}
            className="rounded-full bg-[#171512] px-8 py-4 font-mono text-xs font-medium uppercase tracking-[0.2em] text-[#FDFBF6] transition-colors duration-200 hover:bg-[#F5C7D4] hover:text-[#171512]"
          >
            join now
          </button>
          <p data-testid="hero-counter-text" className="font-mono text-[11px] tracking-[0.22em] text-[#B9822E]">
            {yesText}
          </p>
        </motion.div>
      </div>
    </section>
  );
}
